module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				errorCheckRegEmail1: fox.i18n.getTranslation('errorCheckRegEmail1', 'Please check your registration email:', 'errors'),
				errorCheckRegEmail2: fox.i18n.getTranslation('errorCheckRegEmail2', 'We have sent a Welcome e-mail that includes access details.', 'errors'),
				errorEmailDoNotExist: fox.i18n.getTranslation('errorEmailDoNotExist', 'This e-mail address does not exist in our database.<br>Maybe you have made an error', 'errors')
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Registration_Congratulations', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					api: {
						widget: 'Api',
						method: 'registration.sendReminder'
					}
				},

				handleDom: {
					focus: {
						target: '#email-reminder',
						event: 'focus',
						callback: 'hideError'
					},

					submit: {
						target: '.send',
						event: 'click',
						callback: 'submit'
					}
				},

				handleWom: {
					apiResponse: {
						widget: '#api',
						event: 'success',
						callback: '_handleApiResponse'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			if (fox.cookie.get('xxx_domain')) {
				this.setTemplateOptions({xxx_domain: true});
			}
		},

		hideError: function (el) {
			fox.dom.removeClass('error', el);
		},

		showError: function () {
			fox.dom.addClass('error', this.dom1('#email-reminder'));
		},

		submit: function () {
			var email = this.dom1('#email-reminder').value;

			if (!email.length) {
				this.showError();

				return;
			}

			this.send(email);
		},

		send: function (email) {
			this.wom1('#api').send({email: email, xsid: ''});
		},

		_handleApiResponse: function (data) {
			var elem = this.dom1('#response-block');

			if (!data.answer.response.success.errors) {
				$(elem).html(_.getTranslation('errorCheckRegEmail1') + ' ' + data.answer.response.success.email + '.<br>' + _.getTranslation('errorCheckRegEmail2'));
			} else {
				$(elem).html(_.getTranslation('errorEmailDoNotExist'));
				this.showError();
			}
		}
	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/registration/congratulations.js
// module id = 355
// module chunks = 2